import React from 'react';
import { createProps, unstable_mapValueToValue, map } from '@spaceship-fspl/substance-style';
import { getSpace, alignItems, paddingTop, paddingLeft, paddingX, justifyContent, display, marginBottom } from '@spaceship-fspl/substance-mixin';
import styled, { css } from 'styled-components';
import flattenChildren from 'react-keyed-flatten-children';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n              margin-left: -", ";\n            "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n              margin-top: calc(-", " - 1px);\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 1px;\n    :before {\n      display: block;\n      content: '';\n      margin-top: -1px;\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var createSpaceStyles = function createSpaceStyles(_ref) {
  var map = _ref.map,
      getSpace = _ref.getSpace,
      paddingTop = _ref.paddingTop,
      paddingLeft = _ref.paddingLeft;
  var wrapper = css(_templateObject(), createProps({
    $spaceY: function $spaceY(space) {
      return map(space, function (s) {
        return css(_templateObject2(), getSpace(s));
      });
    }
  }));
  var container = css(_templateObject3(), createProps({
    $spaceX: function $spaceX(space) {
      return map(space, function (s) {
        return css(_templateObject4(), getSpace(s));
      });
    }
  }));
  var item = css(_templateObject5(), createProps({
    $spaceY: paddingTop,
    $spaceX: paddingLeft
  }));
  return {
    wrapper: wrapper,
    container: container,
    item: item
  };
};

/* eslint-disable @typescript-eslint/camelcase */
var alignXValues = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
var alignYValues = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  stretch: 'stretch',
  baseline: 'baseline'
};
function mapAlignX(alignX) {
  return unstable_mapValueToValue(alignX, function (align) {
    return alignXValues[align];
  });
}
function mapAlignY(alignY) {
  return unstable_mapValueToValue(alignY, function (align) {
    return alignYValues[align];
  });
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n                flex-grow: initial;\n                flex-basis: ", "%;\n                max-width: ", "%;\n              "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n                flex-grow: 1;\n                flex-basis: auto;\n                /* width: auto; */\n                max-width: 100%;\n              "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n                flex-grow: 0;\n                flex-basis: auto;\n                /* width: auto; */\n                max-width: none;\n              "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            margin-left: ", "%;\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", "\n  "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n        justify-content: ", ";\n      "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var createColumnLayout = function createColumnLayout(_ref) {
  var map = _ref.map,
      getSpace = _ref.getSpace,
      alignItems = _ref.alignItems,
      paddingTop = _ref.paddingTop,
      paddingLeft = _ref.paddingLeft;
  var SpaceXContext = React.createContext(undefined);
  var SpaceYContext = React.createContext(undefined);

  function halign(_ref2) {
    var $halign = _ref2.$halign,
        $reverse = _ref2.$reverse;

    //if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
    if (typeof $halign === 'undefined' && typeof $reverse === 'undefined') {
      return "";
    }

    return map($halign, function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'left';
      var rule = '';

      switch (value) {
        case 'left':
          if ($reverse) {
            rule = 'flex-end';
          } else {
            rule = 'flex-start';
          }

          break;

        case 'right':
          if ($reverse) {
            rule = 'flex-start';
          } else {
            rule = 'flex-end';
          }

          break;

        case 'center':
          rule = 'center';
          break;

        default:
          throw new Error("styled-components-grid: halign must be one of \"left\", \"right\", \"center\". Got \"".concat(String(value), "\""));
      }

      return css(_templateObject$1(), rule);
    });
  }

  function reverse(reverse) {
    //if no value is specified, then don't output any css (it just makes it harder for the consumer to override)
    if (typeof reverse === 'undefined') {
      return css(_templateObject2$1());
    }

    return map(reverse, function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return "\n          flex-direction: ".concat(value && 'row-reverse' || 'row', ";\n          flex-wrap: ").concat(value && 'wrap-reverse' || 'wrap', ";\n        ");
    });
  }

  var styles = createSpaceStyles({
    map: map,
    getSpace: getSpace,
    paddingTop: paddingTop,
    paddingLeft: paddingLeft
  });
  var Wrapper = styled.div(_templateObject3$1(), styles.wrapper);
  var Container = styled.div(_templateObject4$1(), halign, styles.container, createProps({
    $alignItems: alignItems,
    $reverse: reverse
  }));
  var Item = styled.div(_templateObject5$1(), styles.item, createProps({
    $offset: function $offset(offset) {
      return map(offset, function (o) {
        var pct = Math.round(o * 100 * 10000) / 10000;
        return css(_templateObject6(), pct);
      });
    },
    $width: function $width(width) {
      return map(width, function (w) {
        switch (w) {
          case 'min':
            {
              return css(_templateObject7());
            }

          case 'max':
            {
              return css(_templateObject8());
            }

          default:
            {
              var pct = Math.round((typeof w === 'number' ? w : 1) * 100 * 10000) / 10000;
              return css(_templateObject9(), pct, pct);
            }
        }
      });
    }
  }));

  var ColumnsLayoutColumn = function ColumnsLayoutColumn(_ref3) {
    var children = _ref3.children,
        offset = _ref3.offset,
        _ref3$width = _ref3.width,
        width = _ref3$width === void 0 ? 1 : _ref3$width,
        otherProps = _objectWithoutProperties(_ref3, ["children", "offset", "width"]);

    return /*#__PURE__*/React.createElement(SpaceXContext.Consumer, null, function (spaceX) {
      return /*#__PURE__*/React.createElement(SpaceYContext.Consumer, null, function (spaceY) {
        return /*#__PURE__*/React.createElement(Item, _extends({}, otherProps, {
          $spaceX: spaceX,
          $spaceY: spaceY,
          $offset: offset,
          $width: width
        }), children);
      });
    });
  };

  var ColumnLayout = function ColumnLayout(_ref4) {
    var spaceX = _ref4.spaceX,
        spaceY = _ref4.spaceY,
        alignX = _ref4.alignX,
        alignY = _ref4.alignY,
        reverse = _ref4.reverse,
        children = _ref4.children,
        otherProps = _objectWithoutProperties(_ref4, ["spaceX", "spaceY", "alignX", "alignY", "reverse", "children"]);

    return /*#__PURE__*/React.createElement(SpaceXContext.Provider, {
      value: spaceX
    }, /*#__PURE__*/React.createElement(SpaceYContext.Provider, {
      value: spaceY
    }, /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
      $spaceY: spaceY
    }), /*#__PURE__*/React.createElement(Container, {
      $alignItems: mapAlignY(alignY),
      $halign: alignX,
      $reverse: reverse,
      $spaceX: spaceX
    }, children))));
  };

  ColumnLayout.Column = ColumnsLayoutColumn;
  return ColumnLayout;
};
var ColumnLayout = createColumnLayout({
  map: map,
  getSpace: getSpace,
  alignItems: alignItems,
  paddingTop: paddingTop,
  paddingLeft: paddingLeft
});

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    width: 100%;\n    margin: auto;\n    ", "\n\n    ", "\n  "]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
function createContainerLayout(_ref) {
  var width = _ref.width,
      space = _ref.space,
      paddingX = _ref.paddingX;
  var Wrapper = styled.div(_templateObject$2(), typeof width === 'function' ? function (_ref2) {
    var theme = _ref2.theme;
    return {
      maxWidth: width(theme)
    };
  } : {
    maxWidth: width
  }, typeof space === 'function' ? function (_ref3) {
    var theme = _ref3.theme;
    return paddingX(space(theme));
  } : space && paddingX(space) || undefined);

  var ContainerLayout = function ContainerLayout(_ref4) {
    var children = _ref4.children,
        otherProps = _objectWithoutProperties(_ref4, ["children"]);

    return /*#__PURE__*/React.createElement(Wrapper, otherProps, children);
  };

  return ContainerLayout;
}
var ContainerLayout = createContainerLayout({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  width: function width(theme) {
    var _ref5, _ref5$container;

    return theme && ((_ref5 = theme) === null || _ref5 === void 0 ? void 0 : (_ref5$container = _ref5.container) === null || _ref5$container === void 0 ? void 0 : _ref5$container.width) || 1200;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  space: function space(theme) {
    var _ref6, _ref6$container;

    return theme && ((_ref6 = theme) === null || _ref6 === void 0 ? void 0 : (_ref6$container = _ref6.container) === null || _ref6$container === void 0 ? void 0 : _ref6$container.space);
  },
  paddingX: paddingX
});

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    ", "\n    ", "\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var createInlineLayout = function createInlineLayout(_ref) {
  var map = _ref.map,
      getSpace = _ref.getSpace,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      paddingTop = _ref.paddingTop,
      paddingLeft = _ref.paddingLeft;
  var styles = createSpaceStyles({
    map: map,
    getSpace: getSpace,
    paddingTop: paddingTop,
    paddingLeft: paddingLeft
  });
  var Wrapper = styled.div(_templateObject$3(), styles.wrapper);
  var Container = styled.div(_templateObject2$2(), styles.container, createProps({
    $alignItems: alignItems,
    $justifyContent: justifyContent
  }));
  var Item = styled.div(_templateObject3$2(), styles.item);

  var InlineLayout = function InlineLayout(_ref2) {
    var spaceX = _ref2.spaceX,
        spaceY = _ref2.spaceY,
        alignX = _ref2.alignX,
        alignY = _ref2.alignY,
        children = _ref2.children,
        otherProps = _objectWithoutProperties(_ref2, ["spaceX", "spaceY", "alignX", "alignY", "children"]);

    return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
      $spaceY: spaceY
    }), /*#__PURE__*/React.createElement(Container, {
      $justifyContent: mapAlignX(alignX),
      $alignItems: mapAlignY(alignY),
      $spaceX: spaceX
    }, flattenChildren(children).map(function (child, index) {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }

      return /*#__PURE__*/React.createElement(Item, {
        key: child.key || index,
        $spaceX: spaceX,
        $spaceY: spaceY
      }, child);
    })));
  };

  return InlineLayout;
};
var InlineLayout = createInlineLayout({
  map: map,
  getSpace: getSpace,
  alignItems: alignItems,
  justifyContent: justifyContent,
  paddingTop: paddingTop,
  paddingLeft: paddingLeft
});

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
function createHidden(_ref) {
  var display = _ref.mixins.display;
  var Wrapper = styled.div(_templateObject$4(), createProps({
    $display: display
  }));

  var Hidden = function Hidden(_ref2) {
    var hide = _ref2.hide,
        inline = _ref2.inline,
        children = _ref2.children,
        otherProps = _objectWithoutProperties(_ref2, ["hide", "inline", "children"]);

    return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
      // eslint-disable-next-line @typescript-eslint/camelcase
      $display: unstable_mapValueToValue(hide, function (isHidden) {
        return isHidden ? 'none' : inline ? 'inline' : 'block';
      }),
      as: inline ? 'span' : 'div'
    }), children);
  };

  return Hidden;
}
var Hidden = createHidden({
  mixins: {
    display: display
  }
});

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n    :last-of-type {\n      margin-bottom: 0;\n    }\n    ", "\n  "]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    ", "\n  "]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var createStackLayout = function createStackLayout(_ref) {
  var display = _ref.display,
      alignItems = _ref.alignItems,
      marginBottom = _ref.marginBottom,
      getChildDisplayValue = _ref.getChildDisplayValue;
  var Wrapper = styled.div(_templateObject$5(), createProps({
    $alignItems: alignItems
  }));
  var Item = styled.div(_templateObject2$3(), createProps({
    $display: display,
    $marginBottom: marginBottom
  }));

  var StackLayout = function StackLayout(_ref2) {
    var alignX = _ref2.alignX,
        spaceY = _ref2.spaceY,
        children = _ref2.children,
        otherProps = _objectWithoutProperties(_ref2, ["alignX", "spaceY", "children"]);

    return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
      $alignItems: mapAlignX(alignX)
    }), flattenChildren(children).map(function (child, index) {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }

      return /*#__PURE__*/React.createElement(Item, {
        key: child.key || index,
        $display: getChildDisplayValue(child),
        $marginBottom: spaceY
      }, child);
    }));
  };

  return StackLayout;
};

function getChildDisplayValue(child) {
  if (child.type === Hidden) {
    if (process.env.NODE_ENV !== 'production') {
      if (child.props.inline) {
        console.error('Hidden cannot be "inline" when a direct child of Stack.');
      }
    } // eslint-disble-next-line @typescript-eslint/camelcase


    return unstable_mapValueToValue(child.props.hide, function (hide) {
      return hide ? 'none' : 'block';
    });
  }

  return undefined;
}

var StackLayout = createStackLayout({
  display: display,
  alignItems: alignItems,
  marginBottom: marginBottom,
  getChildDisplayValue: getChildDisplayValue
});

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n            flex: 0 0 ", ";\n            max-width: ", ";\n          "]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n    flex: 0 0 100%;\n    ", "\n    ", "\n  "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n    ", "\n    ", "\n  "]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var createTileLayout = function createTileLayout(_ref) {
  var map = _ref.map,
      getSpace = _ref.getSpace,
      alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      paddingTop = _ref.paddingTop,
      paddingLeft = _ref.paddingLeft;
  var styles = createSpaceStyles({
    map: map,
    getSpace: getSpace,
    paddingTop: paddingTop,
    paddingLeft: paddingLeft
  });
  var Wrapper = styled.div(_templateObject$6(), styles.wrapper);
  var Container = styled.div(_templateObject2$4(), styles.container, createProps({
    $alignItems: alignItems,
    $justifyContent: justifyContent
  }));
  var OuterItem = styled.div(_templateObject3$3(), styles.item, createProps({
    $columns: function $columns(columns) {
      return map(columns, function (c) {
        var width = "".concat(1 / c * 100, "%");
        return css(_templateObject4$2(), width, width);
      });
    }
  }));

  var TileLayout = function TileLayout(_ref2) {
    var columns = _ref2.columns,
        alignX = _ref2.alignX,
        alignY = _ref2.alignY,
        spaceX = _ref2.spaceX,
        spaceY = _ref2.spaceY,
        children = _ref2.children,
        otherProps = _objectWithoutProperties(_ref2, ["columns", "alignX", "alignY", "spaceX", "spaceY", "children"]);

    return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
      $spaceY: spaceY
    }), /*#__PURE__*/React.createElement(Container, {
      $alignItems: mapAlignY(alignY),
      $justifyContent: mapAlignX(alignX),
      $spaceX: spaceX
    }, flattenChildren(children).map(function (child, index) {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }

      return /*#__PURE__*/React.createElement(OuterItem, {
        key: child.key || index,
        $columns: columns,
        $spaceX: spaceX,
        $spaceY: spaceY
      }, child);
    })));
  };

  return TileLayout;
};
var TileLayout = createTileLayout({
  map: map,
  getSpace: getSpace,
  alignItems: alignItems,
  justifyContent: justifyContent,
  paddingTop: paddingTop,
  paddingLeft: paddingLeft
});

export { ColumnLayout, ContainerLayout, Hidden, InlineLayout, StackLayout, TileLayout, createColumnLayout, createContainerLayout, createHidden, createInlineLayout, createStackLayout, createTileLayout };
//# sourceMappingURL=layout.esm.js.map
